export default __webpack_public_path__ + "static/media/round_layout.9527c66d.jpg";